<template>
  <div
    :id="id"
    :style="adquirirStylesOverlay"
    :class="adquirirClassesDeTipoOverlay"
    class="
      is-trf-global-loader
      is-flex
      is-justify-content-center
      is-align-content-center
      is-align-items-center
    "
  >
    <span
      :style="[adquirirStylesSpinner, adquirirManualSizeSpinner]"
      :class="adquirirBulmaSizeSpinner"
      class="button is-loading is-trf-main-loading is-inline-block"
    ></span>
  </div>
</template>
<script>
export default {
  name: "TrfGlobalLoader",
  props: {
    id: String,
    type: {
      type: [String],
      required: false,
      default: "fixed",
    },
    zIndex: {
      type: [String],
      required: false,
      default: "11",
    },
    overlayColor: {
      type: [String],
      required: false,
     default: "rgba(255,255,255,0.55)",
    },
    spinnerColor: String,
    spinnerSize: {
      type: [String],
      required: false,
      default: "1",
    },
  },
  data() {
    return {
      bulmaSizes: ["1", "2", "3", "4", "5", "6", "7"],
    };
  },
  computed: {
    adquirirClassesDeTipoOverlay() {
      if (this.type == "overlay") {
        return "is-overlay";
      } else {
        return "is-trf-fixed";
      }
    },
    adquirirStylesOverlay() {
      const styles = `z-index: ${this.zIndex};background: ${this.overlayColor};`;
      return styles;
    },
    adquirirStylesSpinner() {
      if (!!!this.spinnerColor) return;

      const styles = `color: ${this.spinnerColor}!important`;
      return styles;
    },
    adquirirBulmaSizeSpinner() {
      if (!!!this.bulmaSizes.includes(this.spinnerSize)) return;

      return `is-size-${this.spinnerSize}`;
    },
    adquirirManualSizeSpinner() {
      if (!!this.bulmaSizes.includes(this.spinnerSize)) return;

      return `font-size: ${this.spinnerSize}`;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.is-trf-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
.is-trf-main-loading {
  background: transparent !important;
  border: 0 none transparent !important;
  outline: 0 none transparent !important;
  pointer-events: none !important;
  color: var(--primaryColor, $primary) !important;
}
.is-trf-main-loading::after {
  border-left-color: currentColor;
  border-bottom-color: currentColor;
}
</style>
